// extracted by mini-css-extract-plugin
export default {"Auctions":"Auctions_Auctions__GqHTg","Auctions__new":"Auctions_Auctions__new__s+pgf","Auctions__table":"Auctions_Auctions__table__UHruY"};